import { useCallback, useState } from 'react';
import SearchInputWithTooltip from '../common/SearchInputWithTooltip';
import useAgentsChats from './useAgentsChats';
import { useUnhappyStates } from '../pages/environments/useUnhappyStates';
import { useSelector } from 'react-redux';
import { selectSearchText } from './agentsChatsReducer';

const AgentSearch = () => {
  const searchText = useSelector(selectSearchText);
  const { getSearchResults, clearSearchResults } = useAgentsChats();
  const [localSearchText, setLocalSearchText] = useState(searchText);
  const { isInitialFetch } = useUnhappyStates();
  const isSearchDisabled = isInitialFetch;

  const clearSearch = useCallback(() => {
    clearSearchResults();
    setLocalSearchText('');
  }, [clearSearchResults]);

  const onSearchKeydown = useCallback(
    async (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.key === 'Escape') {
        clearSearch();
      }
      if (event.key === 'Enter' && !!localSearchText) {
        getSearchResults(localSearchText);
      } else if (event.key === 'Enter' && localSearchText === '') {
        clearSearch();
      }
    },
    [clearSearch, getSearchResults, localSearchText],
  );

  return (
    <SearchInputWithTooltip
      displayTooltip={localSearchText !== '' && localSearchText !== searchText}
      TextFieldProps={{
        autoFocus: true,
        value: localSearchText,
        onChange: (e) => {
          setLocalSearchText(e.target.value);
        },
        onKeyDown: onSearchKeydown,
        disabled: isSearchDisabled,
      }}
      onClearButtonClick={clearSearch}
      withFixedMagnifyingGlassIcon
      size="small"
      variant="dark"
    />
  );
};

export default AgentSearch;
